import api from "./api";

// Aprobaciones: cuando una accion se autoriza con las credenciales de un
// usuario queda registrada la entidad, su id, la fecha y la hora y quien la
// aprobo.
export const getsAutorizacion = async (filters) => {
    const response = await api.get("/Autorizacion/GetsAutorizacion", { params: filters });

    return response.data.data;
}

export default { getsAutorizacion };
